import { queryClient } from '../../shared/providers/react-query-provider';
import { DossierId, SerializedDossiers } from '../dossier/types';

import { getDossierOverviewsQueryKey } from './hooks';

export const getDossierOverviewFromCache = (dossierId: DossierId) => {
    const dossierOverviews = queryClient.getQueryData<SerializedDossiers>(
        getDossierOverviewsQueryKey(),
    );
    return dossierOverviews?.dossier[dossierId];
};
